import { render, staticRenderFns } from "./ValidationData.vue?vue&type=template&id=c4828b44&scoped=true"
import script from "./ValidationData.vue?vue&type=script&lang=js"
export * from "./ValidationData.vue?vue&type=script&lang=js"
import style0 from "./ValidationData.vue?vue&type=style&index=0&id=c4828b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4828b44",
  null
  
)

export default component.exports